<template>
  <div class="positionRelative topCenter t0 l50 w100 projectArea">
    <projectWestKowloon/>
    <projectHKRI/>
    <projectMetrohit/>
    <projectShs618/>
    <projectTaiO/>
    <projectFhkccc/>
    <projectCsass/>
    <projectAQ/>
    <projectAR101/>
    <projectSS/>
    <proejctVending/>
    <projectVS/>
    <projectSKII/>
    <projectOralB/>
    <projectJure/>
    <projectVehicle/>
    <projectIVE2/>
    <projectIVE1/>
    <projectTowngas/>
    <projectGGJ/>
    
  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '@/store'
import projectWestKowloon from './projects/projectWestKowloon'
import projectHKRI from './projects/projectHKRI.vue';
import projectMetrohit from './projects/projectMetrohit.vue';
import projectShs618 from './projects/projectShs618.vue';
import projectTaiO from './projects/projectTaiO.vue';
import projectFhkccc from './projects/projectFhkccc.vue';
import projectCsass from './projects/projectCsass.vue';
import projectAQ from './projects/projectAQ.vue';
import projectAR101 from './projects/projectAR101.vue'
import projectSS from './projects/projectSS.vue';
import proejctVending from './projects/projectVending.vue';
import projectVS from './projects/projectVS.vue';
import projectSKII from './projects/projectSKII.vue';
import projectOralB from './projects/projectOralB.vue';
import projectJure from './projects/projectJure.vue';
import projectVehicle from './projects/projectVehicle.vue';
import projectIVE2 from './projects/projectIVE2.vue';
import projectIVE1 from './projects/projectIVE1.vue';
import projectTowngas from './projects/projectTowngas.vue';
import projectGGJ from './projects/projectGGJ.vue';


export default {
  name: 'project',
  components: {
    projectWestKowloon,
    projectHKRI,
    projectMetrohit,
    projectShs618,
    projectTaiO,
    projectFhkccc,
    projectCsass,
    projectAQ,
    projectAR101,
    projectSS,
    proejctVending,
    projectVS,
    projectSKII,
    projectOralB,
    projectJure,
    projectVehicle,
    projectIVE2,
    projectIVE1,
    projectTowngas,
    projectGGJ,


    
  },
  data () {
    return {
      language : i18n.locale,
    }
  },
  created(){

  },
  methods:{

  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
  },
}
</script>

<style scoped>

  .projectArea{
    max-width: 150vh;
    /* background-color: #00FF0055; */
  }

</style>



// WEBPACK FOOTER //
// src/components/project.vue